import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import GUI from 'lil-gui';

/**
 * CONSTANTS
 */
const SCENE_BACKGROUND_COLOR = 0x000000; // Fondo negro
const CUBE_COLOR_INTERACTED = new THREE.Color(0xFB9AD1).lerp(new THREE.Color(0x000000), 0.7);

/**
 * Base
 */
// Canvas
const canvas = document.querySelector('canvas.webgl')

// Sizes
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

/**
 * Listen resize events
 */
window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera aspect ratio to match new canvas dimensions
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)

    // update renderer pixel ratio to match new canvas dimensions
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

// Scene
const scene = new THREE.Scene()
scene.background = new THREE.Color(SCENE_BACKGROUND_COLOR)

// Camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height)
camera.position.set(6, 10, 10)
scene.add(camera)

/**
 * Controls
 */
const controls = new OrbitControls(camera, canvas)
controls.enabled = true
controls.enableDamping = true

// Renderer
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

// Cube Geometry
const cubeGeometry = new THREE.BoxGeometry(1, 1, 1)
const totalCubes = 100;
const cubes = [];
const radius = 6; // Radio del cilindro

// Colocar cubos alrededor del cilindro con colores en degradado (arcoíris)
for (let i = 0; i < totalCubes; i++) {
    const height = (Math.random() - 0.5) * 12; // Altura de los cubos a lo largo del cilindro

    // Calcular color basado en la altura para generar el efecto de arcoíris
    const colorPercentage = (height + 6) / 12; // Normalizar el rango de altura [-6, 6] a [0, 1]
    const color = new THREE.Color(`hsl(${colorPercentage * 360}, 100%, ${30 + colorPercentage * 40}%)`);
    const cubeMaterial = new THREE.MeshBasicMaterial({ color: color })
    const cube = new THREE.Mesh(cubeGeometry, cubeMaterial)

    // Distribuir los cubos alrededor del cilindro
    const angle = (i / totalCubes) * Math.PI * 2;
    cube.position.set(
        Math.cos(angle) * radius, 
        height, 
        Math.sin(angle) * radius
    );

    scene.add(cube)
    cubes.push(cube)
}

/**
 * Raycaster and Mouse interaction
 */
const mouse = new THREE.Vector2()

// Mouse move event listener
window.addEventListener('mousemove', (event) => {
    mouse.x = (event.clientX / sizes.width) * 2 - 1
    mouse.y = -(event.clientY / sizes.height) * 2 + 1

    const raycaster = new THREE.Raycaster()
    raycaster.setFromCamera(mouse, camera)
    const intersections = raycaster.intersectObjects(scene.children)
    
    // Reset all cube colors
    scene.children.forEach(child => {
        if (child instanceof THREE.Mesh) {
            child.material.color.set(child.material.color) // Mantener el color original
        }
    })

    // Change color of intersected cube
    if (intersections.length > 0) {
        const cube = intersections[0].object
        cube.material.color.set(CUBE_COLOR_INTERACTED)
        cube.material.transparent = true
        cube.material.opacity = 0.8
    }
})

// Animar rotación de los cubos
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Rotar los cubos alrededor del eje Y
    cubes.forEach((cube, index) => {
        const angle = (index / totalCubes) * Math.PI * 2 + elapsedTime * 0.2;
        cube.position.x = Math.cos(angle) * radius;
        cube.position.z = Math.sin(angle) * radius;
        
        // Rotar sobre su propio eje para más dinamismo
        cube.rotation.x += 0.002;
        cube.rotation.y += 0.002;
    })

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

// Inicializar la animación
tick()
